import {currentUrl} from "../helpers/query_helper";

export default {
  computed: {
    axios_filters() {
      let data = {}
      Object.entries(this.filters).forEach(([key, val]) => {
        if (!val) return
        data[key] = Array.isArray(val) ? val.join(',') : val
      })
      if (this.get_page) {
        data['page'] = this.get_page
      }
      return data
    },
    get_page() {
      if (this.pagination.page > 1) {
        return this.pagination.page
      }
      return 0
    },
    axios_filters_str() {
      let i = 0;
      let new_query = '';
      Object.entries(this.axios_filters).forEach(([key, value]) => {
        if (!value) return
        new_query += `${i++ ? '&' : '?'}${key}=${value}`
      })
      return new_query
    },
  },
  data() {
    return {
      show_all: false,
      filter_watch: null,
      pagination: {
        page: 1,
        last_page: 1,
        total: 0,
        list: []
      },
      filters: {}
    }
  },
  methods: {
    pushNewState() {
      history.pushState('', '', `${currentUrl()}${this.axios_filters_str}`)
    },
    destroyFilterWatch() {
      if (this.filter_watch) {
        this.filter_watch()
      }
    },
    mixGetPagination(arr) {
      if (!Array.isArray(arr) || !arr.length ) return []
      let current_url = `${currentUrl()}`
      return arr.map(el => {
        if (!el.url) return el
        let url_data= (new URL(el.url)).search
        el.url = current_url + url_data
        return el
      })
    }
  }
}
